import styled from '@emotion/styled'
import {
  Box,
  ListNotification,
  Notifications as NotificationsDs,
  PopoverNotifications,
  ListReports,
  palette,
} from '@yuno/design-system-web'
import { useEffect, useRef, useState } from 'react'
import { notificationsType } from '../../utils/constants'
import { useNotifications } from './hooks/notifications'
import { useReports } from './hooks/reports'
import { useFirebase } from './hooks/firebase'
import { useTranslation } from 'react-i18next'
import { InputIcon } from './input-icon'

const BoxStyled = styled(Box)(() => ({
  position: 'relative',
  width: '80px',
}))

const NoReports = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  text-align: center;
  color: ${palette.grey[5]};
`

export const NotificationsComponent = ({ customer }) => {
  const { t } = useTranslation()
  const [saved, setSaved] = useState(false)
  const [notificationUserCode, setNotificationUserCode] = useState(null)
  const [reportData, setReportData] = useState(null)
  const {
    reports,
    reportDownloaded,
    open,
    handleClick,
    handleClose,
    handleDownload,
    handleClickInput,
    handleClickInputReturn,
    openReports,
    handleClickCancel,
    error,
    refetchResponse,
  } = useReports({ saved })

  const onSnapshotExists = (exists, data) => {
    if (!data) return
    let newData = {
      ...data,
      payload: JSON.parse(data.payload),
    }
    newData = {
      ...newData,
      payload: {
        ...newData.payload,
        metadata: JSON.parse(newData.payload.metadata),
      },
    }

    setReportData(newData)
  }
  const { getFirebaseRTDData, notificationNumber, setNotificationNumber } =
    useFirebase({ onSnapshotExists })

  const { notifications, changeState, refetchNotifications } = useNotifications(
    {
      customer: customer,
      open,
      openReports,
    },
  )

  const elemenRef = useRef()

  useEffect(() => {
    if (open) {
      refetchNotifications(notificationUserCode)
      changeState(notificationsType.global, setNotificationNumber)
    }
  }, [open])

  useEffect(() => {
    if (customer) {
      getFirebaseRTDData(customer)
      setNotificationUserCode(customer)
    }
  }, [customer, location.pathname])

  useEffect(() => {
    if (openReports) {
      const date = new Date()
      localStorage.setItem('lastOpen', String(date.getTime()))
      localStorage.getItem('lastOpen') && setSaved((prev) => !prev)
      refetchResponse()
      changeState(notificationsType.reports, setNotificationNumber)
    }
  }, [openReports])

  return (
    <>
      <BoxStyled ref={elemenRef}>
        <NotificationsDs
          newNotifications={notificationNumber}
          handleClick={handleClick}
        />
        <PopoverNotifications
          open={open}
          handleClose={handleClose}
          title={t('notifications.title')}
          anchorEl={elemenRef.current}
          showArrow={false}
          transitionDuration={0}
        >
          <>
            <InputIcon
              placeholder={t('notifications.find')}
              viewAllLabel={t('notifications.viewAll')}
              onClick={handleClickInput}
            />

            <ListNotification notifications={notifications} />
          </>
        </PopoverNotifications>

        <PopoverNotifications
          open={openReports}
          handleClose={handleClose}
          title={t('notifications.reports')}
          anchorEl={elemenRef.current}
          handleClick={handleClickInputReturn}
          showArrow={true}
          transitionDuration={0}
        >
          <>
            {!error ? (
              <ListReports
                reports={reports}
                handleClickDownload={handleDownload}
                handleClickCancel={handleClickCancel}
                data={reportDownloaded}
                downloadHere={t('notifications.reportBody')}
                downloadLabel={t('notifications.download')}
                noReportsYetLabel={t('notifications.noReports')}
                reportFailedLAbel={t('notifications.failed')}
                successLabel={t('notifications.success')}
              />
            ) : (
              <NoReports>{t('notifications.noReports')}</NoReports>
            )}
          </>
        </PopoverNotifications>
      </BoxStyled>
    </>
  )
}
